import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router);


export default new Router({

  routes: [
    {
      path: '/',
      redirect: '/home',
    },
    {
      path: '/home',
      name: 'home',
      component: () => import('../views/Home/index.vue'),
      meta: { keepAlive: true } // 使用 keep-alive 组件保持页面状态

    },
    {
      path: '/details',
      name: 'details',
      component: () => import('../views/Details/index.vue'),
      meta: { keepAlive: false } // 确保详情页不被缓存
    },
  ]
})
